/* @jsx h */
import { defineComponent, h } from "vue";
import { LoyaltyAutomationsPage } from "../../../../ManagerPromotions/subpages/Automations";
import { useGroupAuth } from "@app/vue/providers/GroupAuth";

export const GroupAutomationsPage = defineComponent({
  name: "GroupAutomationsPage",
  setup() {
    const auth = useGroupAuth();
    return () => (
      <LoyaltyAutomationsPage
        scope="group"
        canManage={auth.isGroupAdmin.value}
      />
    );
  },
});
